import { ApplicationState, ValidationResultsState } from "@idw-types/state";
import { createSelector } from "reselect";
import { ValidationResults } from "@idw-types/data/validation-results";
import { CaptureStepTypes } from "@enums/capture-step-types";

export const getValidationResultsState = (state: ApplicationState): ValidationResultsState => {
	return state.validationResults;
};

export const getValidationResults = createSelector(
	getValidationResultsState,
	(state: ValidationResultsState): ValidationResults => {
		return state.validationResults || {};
	});

export const getCaptureStepValidationResults = createSelector(
	[
		(state: ApplicationState) => getValidationResults(state),
		(state: ApplicationState, captureStepType: CaptureStepTypes) => captureStepType
	],
	(validationResults, captureStepType) => validationResults[captureStepType]
);